import { ArrayInput, FormDataConsumer, SimpleFormIterator } from "react-admin";
import Inputs from "./Inputs";

export default function PurchaseItemForm() {
  return (
    <ArrayInput
      source="purchase_items"
      defaultValue={[
        {
          // kalo tdk terlist disini input field
          // di form lain sama2 terupdate
          // saat salah satunya di rubah
          purchase_order_id: "",
          purchase_order_item_id: "",
          order_quantity: "", // disabled
          received_quantity: "",
          name: "", // disabled
          price: "", // disabled
          warehouse_id: "",
        },
      ]}
    >
      <SimpleFormIterator
        disableReordering
        getItemLabel={(index) => `#${index + 1}`}
        fullWidth={true}
        sx={{
          "& .RaSimpleFormIterator-line": {
            border: "none",
          },
        }}
      >
        <FormDataConsumer>{Inputs}</FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
}
